export const handleChangeDataModalTransDetails = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_TRANS_DETAILS', name, value
});